import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { HotelCategory } from '../../../components/HotelCategory/index.js';
import { Container } from '../../../components/HotelDescription/TourOperatorInformation/components/Container.js';
import { Flex } from '../../../primitives/Flex/index.js';
import { ParagraphSmall, ParagraphSmallBold } from '../../../primitives/Typography/index.js';
export const TourOperatorInformation = ({
  tourOperatorName,
  value,
  type,
  name
}) => {
  const {
    t
  } = useTranslation('hotelDescription');
  const brandName = useConfiguration('brandName');
  return _jsxs(Container, {
    gap: "4px",
    children: [_jsx(ParagraphSmall, {
      children: t('nameAndStarsDifferent')
    }), _jsxs(Flex, {
      direction: "row",
      gap: "4px",
      children: [_jsx(ParagraphSmallBold, {
        children: `${tourOperatorName}:`
      }), _jsx(ParagraphSmall, {
        children: name
      }), _jsx(HotelCategory, {
        type: type,
        value: value,
        withTooltip: true
      })]
    }), _jsxs(Flex, {
      direction: "row",
      gap: "4px",
      children: [_jsx(ParagraphSmallBold, {
        children: `${brandName}:`
      }), _jsx(ParagraphSmall, {
        children: name
      }), _jsx(HotelCategory, {
        type: type,
        value: value,
        withTooltip: true
      })]
    })]
  });
};